import { useTranslation } from 'react-i18next';

/**
 * 权限同步按钮组件
 * 当检测到权限不一致时，显示提示图标，hover 时展示缺少的接口数量
 */

import { Button, Tooltip } from '@arco-design/web-react';
import { IconSync } from '@arco-design/web-react/icon';
import React from 'react';
import './styles.less';
import type { PermissionSyncResult } from './types';

export interface PermissionSyncButtonProps {
  /** 权限同步结果 */
  syncResult: PermissionSyncResult;
  /** 按钮文本 */
  buttonText?: string;
  /** 按钮样式 */
  style?: React.CSSProperties;
  /** 按钮类名 */
  className?: string;
}

/**
 * 权限同步按钮
 * 仅展示图标，hover 时显示缺少的接口数量，点击事件由外部 wrapper 处理
 */
export const PermissionSyncButton: React.FC<PermissionSyncButtonProps> = ({
  syncResult,
  buttonText = '',
  style,
  className,
}) => {
  const { t } = useTranslation();
  if (!syncResult.needSync) {
    return null;
  }

  return (
    <Tooltip
      content={t('common:missing.api.permissions', { count: syncResult.missingApis.length })}
    >
      <Button
        type="text"
        size="small"
        loading={syncResult.syncing}
        icon={<IconSync />}
        className={`permission-sync-button ${className || ''}`}
        style={style}
      >
        {buttonText}
      </Button>
    </Tooltip>
  );
};

export default PermissionSyncButton;
